import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';

export interface INavItemProps {
  href: string;
  className?: string,
  children: React.ReactNode;
  active: boolean;
};

const useStyles = makeStyles({
  navItem: {
    display: 'block',
    textDecoration: 'none',
    color: tokens.colorNeutralForeground1,
    paddingLeft: '3em',
    paddingTop: '.5em',
    paddingBottom: '.5em',
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground2Hover
    },
    userSelect: 'none',
  },
  active: {
    backgroundColor: tokens.colorNeutralBackground2Selected,
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground2Selected
    }
  },
});


export function NavItem(props: INavItemProps) {
  const { href, active, children } = props;
  const classes = useStyles();
  const navigate = useNavigate();

  //TODO(nibeauli): evaluate if this should be overridable
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate(href);
  };

  const className = mergeClasses(
    classes.navItem,
    active ? classes.active : undefined,
    props.className)
  return (
    <a className={className} aria-current={active ? 'page' : undefined} href={href} onClick={onClick}>
      {children}
    </a>
  )
}
